var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF3EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1663 27.5V25.8333C24.1663 24.9493 23.8152 24.1014 23.19 23.4763C22.5649 22.8512 21.7171 22.5 20.833 22.5H14.1663C13.2823 22.5 12.4344 22.8512 11.8093 23.4763C11.1842 24.1014 10.833 24.9493 10.833 25.8333V27.5",
    stroke: "#2F3567",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 19.1667C19.3413 19.1667 20.8337 17.6743 20.8337 15.8333C20.8337 13.9924 19.3413 12.5 17.5003 12.5C15.6594 12.5 14.167 13.9924 14.167 15.8333C14.167 17.6743 15.6594 19.1667 17.5003 19.1667Z",
    stroke: "#FF6F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.167 27.4991V25.8324C29.1664 25.0939 28.9206 24.3764 28.4681 23.7927C28.0156 23.209 27.3821 22.7921 26.667 22.6074",
    stroke: "#2F3567",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 12.6074C24.05 12.791 24.6855 13.208 25.1394 13.7927C25.5932 14.3774 25.8395 15.0964 25.8395 15.8366C25.8395 16.5767 25.5932 17.2958 25.1394 17.8805C24.6855 18.4652 24.05 18.8822 23.333 19.0658",
    stroke: "#FF6F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCustomer);
export default __webpack_public_path__ + "static/media/totalCustomer.43c80ebf8da6bd75cc352e19bbdec78f.svg";
export { ForwardRef as ReactComponent };